// extracted by mini-css-extract-plugin
module.exports = {"section":"CtaSection_section__UwUFq","title":"CtaSection_title__RSjrK","ctaContainer":"CtaSection_ctaContainer__V4tIm"};